import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSolutionsRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "SolutionsRightForYou",
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_16661",
		"data-name": "Group 16661",
		transform: "translate(2.5 5)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12479",
				"data-name": "Path 12479",
				d: "M3,10.25V6.5A2.5,2.5,0,0,1,5.5,4H23a2.5,2.5,0,0,1,2.5,2.5v15A2.5,2.5,0,0,1,23,24H15.5",
				transform: "translate(-1.75 -4)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12480",
				"data-name": "Path 12480",
				d: "M10.75,20.521l-.314-.787a2.88,2.88,0,0,0-.72-1.049h0a2.885,2.885,0,0,0-1.961-.769H4.995a2.888,2.888,0,0,0-1.961.769h0a2.88,2.88,0,0,0-.72,1.049L2,20.521",
				transform: "translate(-2 -0.521)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12481",
				"data-name": "Path 12481",
				d: "M7.484,12.641a2.188,2.188,0,1,1-3.094,0,2.189,2.189,0,0,1,3.094,0",
				transform: "translate(-1.563 -2)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12482",
				"data-name": "Path 12482",
				d: "M11,16.5V9",
				transform: "translate(0.25 -2.75)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12483",
				"data-name": "Path 12483",
				d: "M14,15.83V11.68",
				transform: "translate(1 -2.08)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12484",
				"data-name": "Path 12484",
				d: "M17,11.112V9.55",
				transform: "translate(1.75 2.638)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 2
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12485",
		"data-name": "Path 12485",
		d: "M0,0H30V30H0Z",
		fill: "none"
	})]
});
export default SvgSolutionsRight;
